import React from 'react';
import { Alert, AlertVariant } from '../../../../components/Alert';
import styles from './AddRiskyIdForm.module.css';

interface RiskyIdFormFieldsProps {
  idNumber: string;
  reason: string;
  active: boolean;
  onIdNumberChange: (value: string) => void;
  onReasonChange: (value: string) => void;
  onActiveChange: (value: boolean) => void;
  isIdNumberDisabled?: boolean;
  showAlert?: boolean;
}

const RiskyIdFormFields: React.FC<RiskyIdFormFieldsProps> = ({
  idNumber,
  reason,
  active,
  onIdNumberChange,
  onReasonChange,
  onActiveChange,
  isIdNumberDisabled = false,
  showAlert = false
}) => (
  <>
    <div className="mb-3">
      <label htmlFor="id_number" className="form-label"> {/* skipcq: JS-0752 */}
        ID Number <span className="text-danger">*</span>
      </label>
      <input
        type="text"
        id="id_number"
        name="id_number"
        className={`form-control ${styles.formInput} ${isIdNumberDisabled ? styles.disabledInput : ''}`}
        value={idNumber}
        onChange={(e) => onIdNumberChange(e.target.value)}
        maxLength={30}
        placeholder="Enter ID number"
        required
        disabled={isIdNumberDisabled}
      />
      <small className="form-text text-muted">
        {idNumber.length}/30 characters
      </small>
    </div>

    <div className="mb-3">
      <label htmlFor="reason" className="form-label"> {/* skipcq: JS-0752 */}
        Reason
      </label>
      <textarea
        id="reason"
        name="reason"
        className={`form-control ${styles.formTextarea}`}
        rows={4}
        value={reason}
        onChange={(e) => onReasonChange(e.target.value)}
        maxLength={250}
        placeholder="Enter reason for flagging this ID number"
        required={false}
      />
      <small className="form-text text-muted">
        {reason.length}/250 characters
      </small>
    </div>

    <div className="mb-3">
      <label htmlFor="active" className="form-label"> {/* skipcq: JS-0752 */}
        Active
      </label>
      <div className={`${styles.activeToggle} ${styles.switchContainer}`}>
        <input
          className={styles.switchInput}
          type="checkbox"
          id="active"
          checked={active}
          onChange={(e) => onActiveChange(e.target.checked)}
          role="switch"
          aria-checked={active}
          aria-label="Toggle active status"
        />
        <label
          aria-hidden="true"
          htmlFor="active"
          className={`${styles.toggleSwitch} ${active ? styles.active : ''}`}>{/* skipcq: JS-0752 */}
          <div className={`${styles.toggleSlider} ${active ? styles.active : ''}`} />
        </label>
      </div>
      <small className="form-text text-muted">
        When inactive, this ID number will not restrict employee access
      </small>
    </div>

    {showAlert && (
      <Alert variant={AlertVariant.Pink}>
        Any employee profile associated with this ID number will have restricted access to sensitive features.
      </Alert>
    )}
  </>
);

export default RiskyIdFormFields;